import axios from 'axios';
import keycloak from '../keycloak';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Enable sending cookies for cross-domain requests
});

apiClient.interceptors.request.use(
  async (config) => {
    // Ensure token is fresh before each request
    if (keycloak.authenticated) {
      try {
        // Try to refresh token if it's about to expire (within 30 seconds)
        await keycloak.updateToken(30);
      } catch (error) {
        console.error('Failed to refresh token', error);
        // Token refresh failed, redirect to login
        keycloak.login();
        return Promise.reject(error);
      }
    }

    // Add token to request header
    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized request, redirecting to login');
      // Token is invalid or expired
      try {
        await keycloak.updateToken(30);
        // Retry the original request
        const originalRequest = error.config;
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        // Refresh failed, redirect to login
        keycloak.login();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
